// @flow
import * as React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import LinkButton from 'app/components/Tariff/LinkButton';
import RadioButton from 'app/common/ui/RadioButton';
import Confirmation from 'app/components/Tariff/Confirmation';
import confirmation from 'app/components/Tariff/Confirmation/confirmationState';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';

import type { Sub, MonthDailyParams, MonthDailyPeriod } from '../../Tariff';
import withSubscribePeriods from './withSubscribePeriods';
import styles from './MonthDailyPeriods.scss';


type Props = {
  subId: string,
  sub?: Sub,
  params?: MonthDailyParams,
  periods: Array<MonthDailyPeriod>,
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  isOpen: boolean,
  beginConfirmation: (e: SyntheticEvent<HTMLElement>) => void,
  stopConfirmation: (void) => void,
  handleCheck: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  submitting: boolean,
  months: ?number,
  comment: string,
  confirmationState: string,
  footnotes: Object,
  locked?: boolean,
  studentId: number,
  tariffId?: number,
  tariffBundleId?: number,
};

/**
 * Версия компонента MonthDailyPeriods для случаев,
 * если еще не оформлена подписка ни на один пакет
 */

const MonthDailyPeriodsSubscribe = ({
  subId,
  params, // eslint-disable-line no-unused-vars
  periods,
  handleToggle,
  isOpen,
  beginConfirmation,
  stopConfirmation,
  handleCheck,
  handleSubmit,
  submitting,
  months,
  comment,
  confirmationState,
  footnotes,
  locked,
  studentId,
  tariffId,
  tariffBundleId,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.title}>
          {`${t('available_subscriptions')}:`}
          {footnotes.monthDailyPause
            && <sup className={styles.fn}>{footnotes.monthDailyPause.index}</sup>}
        </div>
        {isOpen
          ? periods.map(({ months_number: num, title /* , cost */ }) =>
            <RadioButton
              key={title}
              name={String(num)}
              onChange={handleCheck}
              checked={months === num}
              className={styles.radio}
              label={
                <span className={styles.label}>
                  <span>{title}</span>
                  {/* <span className={styles.cost}>{cost}</span> */}
                  <PriceDiscounted
                    className={styles.cost}
                    studentId={studentId}
                    tariffId={tariffId}
                    tariffBundleId={tariffBundleId}
                    priceType={priceTypes.price_base_on_months}
                    monthsNumber={num}
                  />
                </span>
              }
            />)
          : periods.map(({ title, months_number: num /* cost */ }) =>
            <div key={title} className={styles.row}>
              <span className={styles.rowTitle}>{title}</span>
              {/* <span className={styles.rowCost}>{cost}</span> */}
              <PriceDiscounted
                className={styles.rowCost}
                studentId={studentId}
                tariffId={tariffId}
                tariffBundleId={tariffBundleId}
                priceType={priceTypes.price_base_on_months}
                monthsNumber={num}
              />
            </div>)}
      </div>
      {subId && <div className={classNames(styles.content, styles.buttons)}>
        {isOpen && <Confirmation
          onSubmit={handleSubmit}
          comment={comment}
          beginConfirmation={beginConfirmation}
          stopConfirmation={stopConfirmation}
          injectPrice={months
            ? <PriceDiscounted
              studentId={studentId}
              tariffId={tariffId}
              tariffBundleId={tariffBundleId}
              priceType={priceTypes.price_base_on_months}
              monthsNumber={months}
            />
            : null}
        >
          {handle =>
            <LinkButton
              primary
              onClick={handle}
              name="submit"
              disabled={!months || submitting}
            >
              {submitting
                ? t('subscribe_link_loading')
                : t('subscribe_link')}
            </LinkButton>
          }
        </Confirmation>}
        {!confirmationState
          && !locked
          && <LinkButton
            primary={!isOpen}
            onClick={handleToggle}
            name="showPacks"
          >
            {isOpen ? t('back_link') : t('buy_subscribe')}
          </LinkButton>}
      </div>}
    </div>
  );
};

export default withSubscribePeriods(confirmation(MonthDailyPeriodsSubscribe));
